module.exports = "<app-contract-list></app-contract-list>\r\n"